import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';

@Injectable({providedIn: 'root'})
export class OnboardingService {
  private readonly triggerSubject = new Subject<void>();
  readonly trigger$ = this.triggerSubject.asObservable();

  run(): void {
    this.triggerSubject.next();
  }
}
